import { render, staticRenderFns } from "./AspNetRoleEditCard.vue?vue&type=template&id=55cd9ea2&scoped=true"
import script from "./AspNetRoleEditCard.vue?vue&type=script&lang=js"
export * from "./AspNetRoleEditCard.vue?vue&type=script&lang=js"
import style0 from "./AspNetRoleEditCard.vue?vue&type=style&index=0&id=55cd9ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd9ea2",
  null
  
)

export default component.exports